module.exports = __webpack_public_path__ + "88cbfe547c8bec519fbe98c25b76cc5c.jpg";